<template>
  <div class="container-fluid my-3 oral-exam" style="min-height:50vh">
    <div class="row" v-if="exam">
      <div class="col-12" v-if="!doExam">
        <span>本測驗，共有 <span style="font-weight: bold;">{{ exam.lessons.length }}</span>大題，共 <span style="font-weight: bold;">{{ exam.question_count }}</span>句，<span style="font-weight: bold; color:red;">{{ exam.unfinished_count }}</span>句未完成</span>
        <table class="rwd-table mt-3">
          <thead>
            <tr>
              <th colspan="5" class="main-title">{{ exam.name }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>題號</th>
              <th>單元名稱</th>
              <th>已作答句數/單元總句數</th>
              <th>開始測驗</th>
            </tr>
            <tr v-for="(item, index) in exam.lessons" :key="index">
              <td data-th="題號">
                {{index + 1}}
              </td>
              <td data-th="單元名稱">
                {{item.name}}
              </td>
              <td data-th="已作答句數/單元總句數">
                {{item.sentences.filter((el)=>{return el.score != null}).length+'/' + item.sentences.length}}
              </td>
              <td data-th="開始測驗">
                <button type="button" class="btn btn-success" @click="selectedExam(item, index)">開始</button>
              </td>
            </tr>
          </tbody>
        </table>
        <button style="float:right" type="button" @click="postExamAlert()" class="btn btn-outline-danger justify-content-between mt-2">交卷</button>
      </div>
      <div class="col-12" v-else>
        <h3>
          {{examName}}
        </h3>
        <span style="float:right;">點擊錄音鍵即開始作答，錄音後請耐心等待語音辨識完成。(底色由藍轉綠)</span>
        <div v-for="(item, index) in sentences" :key="index">
          <div @click="playAudio(item.no)" v-if="item.is_selected===true" style="width:100%" :class="{'active':item.no===current, 'finish': item?.score!=null}" class="pointer alert alert-primary d-flex justify-content-between align-items-center">{{ item.text }}
            <div>
              <span v-if="item.no===current" >
                <span v-if="countdown>0" >{{`${countdown}秒後結束錄音`}}</span>
              </span>
              <span v-if="showScore === true">
                <span class="mx-2" v-if="item.score">成績: {{item.score}}</span>
              </span>
              <button type="button" v-if="item.score!=null && is_repeatable==0" class="btn btn-danger ml-2" disabled>錄音</button>
              <button type="button" v-else class="btn btn-danger ml-2" @click.stop.prevent="startRecording(item)">錄音</button>
            </div>
          </div>
          <audio :id="`audio${item.no}`">
            <source :src="item.audio" type="audio/mp3">
          </audio>
        </div>
        <!-- <audio controls ref="audioPlayer">
          <source type="audio/wav">
        </audio> -->
        <button style="float:right" type="button" @click="finishExam" class="btn btn-outline-danger justify-content-between mt-2">結束作答</button>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import 'vue2-datepicker/index.css'
import api from '../store/api'
import audioBufferToWav from 'audiobuffer-to-wav'
import AudioResampler from 'audio-resampler'
import axios from 'axios'

export default {
  name: 'Oral-Exam',
  data () {
    return {
      doExam: false,
      current: null,
      examIndex: 0,
      exam: null,
      friendlyId: null,
      examName: '',
      sentences: [],
      recording: false,
      countdown: 0,
      isCounting: false,
      timer: null,
      mediaRecorder: null,
      audioChunks: [],
      audioUrl: '',
      showScore: true
    }
  },
  components: {
    // Pagination,
    // DatePicker
  },
  computed: {
    examId () {
      return this.$route.params.examId
    },
    groupId () {
      return this.$store.state.personalData.group_id
    },
    is_repeatable () {
      return this.$route.params.repeatable
    }
  },
  mounted () {
    this.startExam()
    this.getExamList()
  },
  methods: {
    async startExam () {
      const { data } = await api.post(`liveabc/rooms/${this.examId}/start`)
      this.showScore = data.data.is_show_score
    },
    async getExamList () {
      const { data } = await api.get(`liveabc/rooms/${this.examId}`)
      this.exam = data.data
      this.sentences = data.data.lessons[this.examIndex].sentences
    },
    selectedExam (item, index) {
      this.examIndex = index
      this.doExam = true
      this.examName = item.name
      this.friendlyId = item.friendly_id
      this.getExamList()
    },
    startRecording (el) {
      if (this.countdown === 0) {
        this.current = el.no
      }
      if (this.recording === true) {
        return
      }
      try {
        this.pauseAll()
        this.recording = true
        this.startTimer(el)
      } catch (e) {
        alert(e)
        this.stopAll()
      }
    },
    startTimer (el) {
      let spaces = el.text.split(" ").length - 1
      this.countdown = Math.ceil((spaces + 1) * 0.5) + 3
      this.startCountdown(el)
    },
    playAudio (id) {
      if (this.exam.sound_playable === false) {
        return
      }
      if (this.recording === true) {
        return
      }
      this.current = id
      let audio = document.getElementById(`audio${id}`)
      this.pauseAll()
      audio.load()
      audio.play()
    },
    pauseAll () {
      const audios = document.getElementsByTagName('audio')
      const self = this
      const allAudios = []
      allAudios.forEach.call(audios, function (i) {
        i.currentTime = 0
        i !== self && i.pause()
      })
    },
    startCountdown(el) {
      this.isCounting = true
      this.doRecording(el)
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.stopCountdown()
        }
      }, 1000)
    },
    stopCountdown() {
      clearInterval(this.timer)
      this.stopRecording()
      this.isCounting = false
      this.recording = false
    },
    async Upload (el, blob) {
      const ersUrl = 'https://voicerecognition.liveabc.com/api/ERS'
      const { data } = await axios.post(ersUrl + '?stext=' + encodeURI(el.text), blob)
      this.postAnswer(el, data.Id)
    },
    async doRecording(el) {
      console.log(el)
      try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        this.audioChunks = []
        this.mediaRecorder = new MediaRecorder(stream)
        const audioContext = new (window.AudioContext || window.webkitAudioContext)()
        const targetSampleRate = 16000;
        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.audioChunks.push(event.data)
          }
        }
        const vm = this
        this.mediaRecorder.onstop = async () => {
          const audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' })

          const resampler = new AudioResampler(URL.createObjectURL(audioBlob), targetSampleRate, async function(event) {
            try {
              const audioBuffer = await event.getAudioBuffer ()
              const wavData = audioBufferToWav(audioBuffer)
              const wavBlob = new Blob([wavData], { type: 'audio/wav' })
              vm.Upload(el,wavBlob)
            } catch (error) {
              console.error('Error:', error);
            }
          })
          const audioUrl = URL.createObjectURL(audioBlob)
          if (this.$refs.audioPlayer) {
            this.$refs.audioPlayer.src = audioUrl
          }
          this.audioUrl = audioUrl
        }
        this.mediaRecorder.start()
        this.recording = true
      } catch (error) {
        console.error('錄音失敗：', error)
      }
    },
    async postAnswer(el,friendlyId) {
      const vm = this
      const fileData = new FormData()
      fileData.append('recognitionId', friendlyId)
      fileData.append('sent_no', el.sent_no)
      try {
        const data = await api.post(`liveabc/rooms/${this.examId}/answers/${el.no}`, fileData)
        el.score = data.data.data.score
      } catch (error) {
        vm.$swal({
          title: '上傳錄音失敗，請重複嘗試',
          icon: 'error',
          showCancelButton: false,
          confirmButtonText: '確定'
        })
        console.error('上傳錄音失敗：', error)
      }
    },
    stopRecording() {
      if (this.mediaRecorder) {
        this.mediaRecorder.stop()
        this.recording = false
      }
    },
    finishExam () {
      this.doExam = false
      this.examName = ''
      this.sentences = []
      this.friendlyId = null
      this.pauseAll()
      this.stopCountdown()
      this.getExamList()
    },
    postExamAlert () {
      let self = this
      self.$swal({
        title: '確認交卷?',
        html: self.exam.unfinished_count > 0 ?'<span style="color:red">題目尚未全數作答</span>':'',
        showCancelButton: true,
        confirmButtonText: '確認',
        cancelButtonText: '取消',
        closeOnConfirm: false
      }).then(function (isConfirm) {
        if (isConfirm.value === true) {
          self.postExam()
        }
      })
    },
    async postExam () {
      const vm = this
      try {
          await api.post(`liveabc/rooms/${this.examId}/finish`)
          this.$router.push({ name: 'Exam-hall'})
        } catch (error) {
          console.error(error.response.data)
          vm.$swal({
            title: '交卷失敗，請重複嘗試',
            icon: 'error',
            showCancelButton: false,
            confirmButtonText: '確定'
          })
        }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/color.scss";
.oral-exam {
  text-align: left;
}
table {
  border-collapse: collapse;
  width: 100%;
  overflow: auto;
}
th {
  overflow:hidden;
  color: #fff;
  text-align: center !important;
  padding: 8px;
}
tr:nth-child(even){
  background-color:#e8e8e8 !important;
}
/*表格中的奇數對 tr*/
tr:nth-child(odd){
  background-color:#d8d8d8 !important;
}
td {
  font-weight: bold;
  // background-color: rgb(230, 230, 230);
  border: 4px solid #fff;
  text-align: center !important;
  padding: 8px;
}
.active {
  font-weight: bold;
  box-shadow: rgb(168, 168, 168) 5px 5px 15px;
}
.finish {
  background-color: #d1e7dd;
}
.rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
background-color: #ebf3f9;
}

.rwd-table tbody th {
display: none;
}

.rwd-table td {
display: block;
}

.rwd-table td:first-child {
margin-top: .5em;
}

.rwd-table td:last-child {
margin-bottom: .5em;
}

.rwd-table td:before {
content: attr(data-th) ": ";
font-weight: bold;
width: 120px;
display: inline-block;
color: #000;
}

.rwd-table th,
.rwd-table td {
text-align: left;
}

.rwd-table tr {
border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
padding: .5em 1em;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table tbody th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
